export const MOBILE_MAP_SIDEBAR_CLASS_NAMES =
    'height-50vh position-absolute bottom-0 left-0 right-0 shadow-hard rounded-top-large overflow-hidden';

export const MOBILE_MAP_CLUSTER_SIDEBAR_CLASS_NAMES = 'padding-bottom-10 shadow-hard rounded-top-large overflow-hidden';

export const getMobileMapSidebarClassNames = (isMobile: boolean) => (isMobile ? MOBILE_MAP_SIDEBAR_CLASS_NAMES : '');
